export const isHandleBars = (offset: number, v: string): boolean => {
  const minRangeSnap = v.slice(offset - 1, offset + 3) === '{{}}';
  const maxRangeSnap = v.slice(offset - 2, offset + 4) === '{{{}}}';
  const tooManyBrackets = v.slice(offset - 3, offset + 5) === '{{{{}}}}';
  return (minRangeSnap || maxRangeSnap) && !tooManyBrackets;
};

const getDimensionInfoFromEditor = (regex: RegExp, className: string): string => {
  const styleAttribute = document.getElementsByClassName(className)[0].attributes['style'].nodeValue;
  return regex.exec(styleAttribute).slice(1)[0];
};

const getLineHeight = (): number => {
  const regex = /line-height: (\d+)/gi;
  const className = 'view-lines monaco-mouse-cursor-text';
  return +getDimensionInfoFromEditor(regex, className);
};

const getColumnWidth = (): number => {
  const element = document.getElementsByClassName('view-lines monaco-mouse-cursor-text')[0];
  const style = window.getComputedStyle(element);
  const fontFamily = style.getPropertyValue('font-family').split(',')[0];
  const fontSize = style.getPropertyValue('font-size');
  const sample = ' ';

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = `${fontSize} ${fontFamily}`;
  const width = context.measureText(sample).width;
  return width;
};

const getScrollY = (): number => {
  const regex = /top: (-?\d+)/gi;
  const className = 'margin';
  return +getDimensionInfoFromEditor(regex, className);
};

// checks if the change comes from text addition or deletion
export const getOffsetPosition = (e: any): number => {
  return e.text ? e.rangeOffset : e.rangeOffset - 1;
};

export const getCaretPosition = (e: any) => {
  const lineHeight = getLineHeight();
  const scrollY = getScrollY();
  const columnWidth = getColumnWidth();
  return {
    left: e.startColumn * columnWidth,
    top: e.startLineNumber * lineHeight + scrollY,
  };
};
